<template>
  <a-modal :visible="showDialog" :mask="true" :maskClosable="false" title="编辑" @ok="handleOk" @cancel="handleCancel()">
    <a-form>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item label="姓名" class="col-12">
            <a-input v-model="userInfo.name" placeholder="姓名" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="用户名">
            <a-input v-model="userInfo.user_name" placeholder="用户名" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item label="邮箱">
            <a-input v-model="userInfo.email" placeholder="邮箱" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="手机号">
            <a-input v-model="userInfo.phone" placeholder="手机号" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-form-item label="密码">
        <a-input v-model="userInfo.password" placeholder="密码" />
      </a-form-item>
      <a-form-item label="用户分组">
        <a-select v-model="userInfo.group_name" allowClear :maxTagCount="1" placeholder="请选择用户组" optionFilterProp="label" show-search>
          <a-select-option v-for="groupItem in groupList" :label="groupItem.real_name" :value="groupItem.name"
            :key="groupItem.name">
            {{ groupItem.real_name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="管理员">
        <a-radio-group v-model="userInfo.is_main">
          <a-radio-button value="1">
            是
          </a-radio-button>
          <a-radio-button value="0">
            否
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="状态">
        <a-radio-group v-model="userInfo.status">
          <a-radio-button value="1">
            在职
          </a-radio-button>
          <a-radio-button value="2">
            离职
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { UserSave } from "../../api/v1/user_api";

export default {
  name: "UserAddDialog",
  props: ['userInfo', 'showDialog', 'groupList'],
  data() {
    return {
      formLayout: 'inline',
    }
  },
  methods: {
    handleOk() {
      if (!this.userInfo.name) {
          this.$message.error('请填写姓名')
          return false
      }
      if (!this.userInfo.user_name) {
          this.$message.error('请填写用户名')
          return false
      }
      if (!this.userInfo.email) {
          this.$message.error('请填写邮箱')
          return false
      }
      if (!this.userInfo.password) {
          this.$message.error('请填写密码')
          return false
      }
      let data = {
        "name": this.userInfo.name,
        "user_name": this.userInfo.user_name,
        "email": this.userInfo.email,
        "phone": this.userInfo.phone,
        "password": this.userInfo.password,
        "is_main": this.userInfo.is_main,
        "status": this.userInfo.status,
        "group_name": this.userInfo.group_name,
      }
      UserSave(data).then(resp => {
        if (resp.code === 200) {
          this.$message.success(resp.msg)
          this.$emit('close-dialog')
        } else {
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel() {
      this.$emit('close-dialog')
    }
  }
}
</script>

<style scoped>
.ant-form-item {
  margin-bottom: 0px !important
}
</style>



// WEBPACK FOOTER //
// src/components/V1/UserAddDialog.vue